<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { toast } from "@/common/api/api.js";
import notice from "./centralControl/notice/notice";
// import router from "./router";
import {
  getUserInfoCache,
  getCookie,
  getUserInformation,
  delCookie
} from "@/common/api";
export default {
  name: "app",
  computed: {
    ...mapState(["isLogin"])
  },
  created() {
    //  alert("监听");
    // notice.onBrother("loginRequest",(path)=>{
    //   alert("观察者执行");
    // let sessionId = getCookie("sessionId");
    //     if (!localStorage.isLogin || !localStorage.loginInfo) {
    //       getUserInfoCache({
    //         sessionId: sessionId //.split("#")[1]
    //       }).then(res => {
    //         if (res.code == 200) {
    //           this.$store.commit("changeLogin", "1");
    //           localStorage.setItem("loginInfo", JSON.stringify(res.data));
    //           this.$router.push(path);
    //         }
    //       });
    //     }
    //     if (this.$route.name === "login") {
    //       this.getWxCode();
    //     }
    // });
    // router.beforeEach((to, from, next) => {
    //   debugger
    // })
  },
  mounted() {
    // let sessionId = getCookie("sessionId");
    // if (!localStorage.isLogin || !localStorage.loginInfo) {
    //   getUserInfoCache({
    //     sessionId: sessionId //.split("#")[1]
    //   }).then(res => {
    //     if (res.code == 200) {
    //       this.$store.commit("changeLogin", "1");
    //       localStorage.setItem("loginInfo", JSON.stringify(res.data));
    //       this.$router.push("/login");
    //     }
    //   });
    // }
    // if (this.$route.name === "login") {
    //   this.getWxCode();
    // }
    // if (this.$route.path != "/login" && this.$route.path != "/forget") {
    // let id = JSON.parse(window.localStorage.getItem("loginInfo")).id || "";
    // getUserInformation({
    //   id: id
    // }).then(res => {
    //   if (res.code == 200) {
    //     if (!res.data.status) {
    //       this.$createDialog({
    //         type: "alert",
    //         title: "提示",
    //         content: "登录失效,请重新登录",
    //         icon: "cubeic-alert",
    //         confirmBtn: {
    //           text: "退出",
    //           active: true,
    //           href: "javascript:;"
    //         },
    //         onConfirm: () => {
    //           window.localStorage.clear();
    //           delCookie("sessionId");
    //           location.reload();
    //         }
    //       }).show();
    //     }
    //   }
    // });
    // }
  },
  methods: {
    ...mapMutations(["setLoginInfo", "changeLogin", "setIntegralAll"])
    // getWxCode() {
    //   if (!localStorage.getItem("code")) {
    //     // //测试环境
    //     // let appid = "wx084b8ba94fb5f8dc";
    //     // let redirect_uri = "https://iumswxdev.logimis.com/login";
    //     // test
    //     // let appid = "wx084b8ba94fb5f8dc";
    //     // let redirect_uri = 'https://iumswxtest.logimis.com/login'
    //     // 生产

    //     // let appid = "wxfef7cb3b6b68f2e7";
    //     // let redirect_uri = "https://iumswx.logimis.com/login";

    //     let appid = localStorage.getItem("appId"); // 西安服务器APPID
    //     let redirect_uri = "https://wx.shx.logimis.com/login?appId=" + appid; // 西安服务器地址
    //       // let redirect_uri = "https://wx.union.logimis.com/login?appId=" + appid; // 西安服务器地址

    //     let status = "0";
    //     location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${status}#wechat_redirect`;
    //   }
    // }
  }
};
</script>

<style lang="stylus" type="stylesheet/stylus">
body {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: constant(safe-area-inset-left);
  padding-left: env(safe-area-inset-left);
  padding-right: constant(safe-area-inset-right);
  padding-right: env(safe-area-inset-right);
  -webkit-text-size-adjust: 100% !important;
}

.apply-index-box {
  .van-uploader__preview-image {
    width: 70px;
    height: 70px;
  }
}

.left-lable-box {
  .el-form-item__label {
    padding-left: 8px !important;
  }
}

.own-width {
  .el-form-item__label:before {
    width: 10px;
    display: inline-block;
  }
}

.welfareNew {
  .van-dropdown-menu__bar {
    height: 44px;
  }

  .van-dropdown-item__option {
    text-align: center;
  }

  .van-cell__value {
    display: none;
  }

  .van-dropdown-menu__item {
    justify-content: flex-end;
    padding: 0 20px;
  }

  .van-popup--top {
    width: 40%;
    right: 11px;
    border-radius: 0 0 10px 10px;
    left: auto;
  }
}

#app {
  font-family: '微软雅黑';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  background: #f0f0f4;
}

.signImg {
  width: 150px;
  height: 300px;
  transform: rotate(90deg);
  border: 1px solid #e5e5e5;
}

.el-message--success {
  background-color: #fff;
  border-color: #fff;
}

.el-input__suffix {
  right: 10px !important;
}

.my-content {
  position: absolute;
  top: 44px;
  width: 100%;
  bottom: 0;
  overflow: scroll;
}

.cube-picker-wheel-item {
  /* word-break: normal;
  width: auto;
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 20px;
  font-size: 16px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* padding: 10px 0; */
  /* height: auto; */
}

/* vant tab 样式 */
/* .van-tab--active .van-tab__text {
  color:#38C7C4;
  font-size:15px;
  font-family:PingFang SC;
  font-weight:bold;
} */
.van-tabs__line {
  width: 26px !important;
}

.box-label .van-radio__label {
  color: #888888;
  font-size: 14px;
}

.box-label .van-step--vertical .van-step__circle-container {
  font-size: 20px;
  top: 27px;
}

.ctn_top {
  margin-top: 44px;
}

// .apply {
// .el-select-dropdown__item.selected {
// color: red !important;
// }
// }

// 我的福利上下拉刷新组件样式
.welfareNew {
  .van-pull-refresh {
    height: 100%;
    overflow: scroll;
  }

  .van-list {
    height: 100%;
  }
}

// 首页的功能专区
.grid-box {
  .van-grid-item__content {
    padding: 10px 0;
  }

  .van-grid-item {
    padding-top: 25% !important;
  }
}

// 弹框优先级
.cube-popup {
  z-index: 200 !important;
}

// toast优先级
.cube-toast {
  z-index: 3000 !important;
}

// toast弹窗文字过多时，最多三行
.cube-toast-tip {
  max-height: 1.5rem !important;
}

.el-loading-spinner .path{
  stroke:#29bebc !important;
}
</style>
